//Components
import Cards from '../containers/Tourbooks/Cards'
import Translate from '../i18n/Translate'
import OperatorsGallery from '../components/OperatorsGallery'
//Hooks
import useScrollTop from '../hooks/useScrollTop'
//Intersection
import { useInView } from 'react-intersection-observer'
import useSetI18nProviderInformation from '../hooks/useSetI18nProviderInformation'

const Tourbooks = () => {
    useScrollTop()
    useSetI18nProviderInformation('manuals_tourbooks')

    const [manualsTop, inView] = useInView({
        triggerOnce: true,
        threshold: 0.5,
    })

    return (
        <main className="incoming-tourbooks">
            <section className="incoming-tourbooks__top">
                <div className={`content animate slide-title ${inView ? 'in-view' : ''}`} ref={manualsTop}>
                    <h1 className="title top-title">
                        <Translate langkey="tourbooks.title" />
                    </h1>
                </div>
            </section>

            <Cards />

            <OperatorsGallery />
        </main>
    )
}

export default Tourbooks
